import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import * as THREE from 'three';
import {
  NgxCameraComponent,
  NgxRendererComponent,
  NgxSceneComponent,
  NgxMeshComponent,
  IRendererEvent,   // ✅ este es el tipo correcto
} from 'ngx3js';

@Component({
  selector: 'app-view-warehouse-cylinder',
  templateUrl: './view-warehouse-cylinder.component.html',
  styleUrls: ['./view-warehouse-cylinder.component.scss']
})
export class ViewWarehouseCylinderComponent implements OnInit, AfterViewInit {
  @ViewChild('renderer3d', { static: false }) rendererComp!: NgxRendererComponent;
  @ViewChild('camera', { static: false }) camera!: NgxCameraComponent;
  @ViewChild('scene', { static: false }) scene!: NgxSceneComponent;
  @ViewChild('liquidMesh', { static: false }) liquidMesh!: NgxMeshComponent;
  @ViewChild('containerMesh', { static: false }) containerMesh!: NgxMeshComponent;

  @Input() radius: number = 0;
  @Input() length: number = 0;
  @Input() percentageFull: number = 0;
  @Input() liquidColor: string = "#0086E3";

  angle = 0;
  mathPiValue: number = Math.PI;
  minusMathPiValue: number = this.mathPiValue * (-1);

  // Tooltip
  tooltipVisible = false;
  tooltipText = 'Contenido del cilindro, si funcionar <br> asdfasd asdfasd Aleste es la linea';
  tooltipX = 0;
  tooltipY = 0;

  private raycaster = new THREE.Raycaster();
  private mouse = new THREE.Vector2();
  private originalColor: THREE.Color | null = null;

  private basePositions: Float32Array | null = null;
  private waveParams = [
    { height: 0.1, frequency: 1, speed: 2 },
    // { height: 0.1, frequency: 4, speed: 1.5 },
    // { height: 0.05, frequency: 3, speed: 2.5 }
  ];

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.adjustCameraToCylinder();
      this.updateTooltipCenter(); // ← aquí
    }, 100);

    const mesh = this.liquidMesh?.getMesh();
    if (mesh) {
      const mat = mesh.material as THREE.MeshStandardMaterial;
      this.originalColor = mat.color.clone(); // Guardamos color original
    }
  }

  private adjustCameraToCylinder() {
    if (!this.camera) return;

    // Tomamos el cilindro como referencia
    const maxDimension = Math.max(this.radius * 2, this.length); // ancho o alto
    const distanceFactor = 1.75; // ajusta la distancia para que se vea un poco separado

    // Posición de la cámara inicial (en diagonal para ver el cilindro completo)
    const camDistance = maxDimension * distanceFactor;
    const angle = Math.PI / 4; // 45 grados para eje X y Z

    let x = -camDistance * Math.cos(angle);
    let y = maxDimension / 3;     // altura central del cilindro
    let z = -camDistance * Math.sin(angle);

    this.camera.setPosition(x, y, z);

    // Apuntar la cámara al centro del cilindro
    const mesh = this.liquidMesh?.getMesh();
    if (mesh) {
      const bbox = new THREE.Box3().setFromObject(mesh);
      const center = new THREE.Vector3();
      bbox.getCenter(center);

      // this.camera.lookAt(center.x, center.y, center.z);
      this.camera.setLookat(center.x, center.y, center.z);
    }

    // Opcional: actualizar controles si usas orbit
    this.rendererComp?.getRenderControl()?.updateInputParams;
  }

  onMouseMove(event: MouseEvent) {
    const canvas = this.rendererComp.getRenderer().domElement;
    const rect = canvas.getBoundingClientRect();

    // Coordenadas normalizadas [-1,1] para raycaster
    this.mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
    this.mouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;

    this.checkIntersection(event.clientX - rect.left, event.clientY - rect.top);
  }

  private checkIntersection(mouseX: number, mouseY: number) {
    if (!this.camera || !this.liquidMesh) return;

    const cam = this.camera.getCamera();
    this.raycaster.setFromCamera(this.mouse, cam);

    const mesh = this.liquidMesh.getMesh();
    if (!mesh) return;

    const intersects = this.raycaster.intersectObject(mesh);

    const mat = mesh.material as THREE.MeshStandardMaterial;
    if (intersects.length > 0) {
      this.tooltipVisible = true;

      // Posición exacta del mouse dentro del canvas
      this.tooltipX = mouseX;
      this.tooltipY = mouseY - 20; // 20px por encima del cursor

      mat.color.set('#FFFF99'); // amarillo semi
    } else {
      this.tooltipVisible = false;
      if (this.originalColor) mat.color.copy(this.originalColor);
    }
  }

  private updateTooltipCenter() {
    const mesh = this.liquidMesh?.getMesh();
    const cam = this.camera?.getCamera();
    const renderer = this.rendererComp?.getRenderer();
    if (!mesh || !cam || !renderer) return;

    // Calculamos el centro del mesh
    const bbox = new THREE.Box3().setFromObject(mesh);
    const center = new THREE.Vector3();
    bbox.getCenter(center);

    // Proyectamos el centro a coordenadas normalizadas de pantalla
    const vector = center.clone().project(cam);

    const widthHalf = renderer.domElement.clientWidth / 2;
    const heightHalf = renderer.domElement.clientHeight / 2;

    // Convertimos a coordenadas en pixels dentro del canvas
    this.tooltipX = vector.x * widthHalf + widthHalf;
    this.tooltipY = -vector.y * heightHalf + heightHalf;

    this.tooltipVisible = false;
  }

  onAnimate() {
    const mesh = this.liquidMesh?.getMesh();
    if (!mesh) return;

    const geometry = mesh.geometry as THREE.BufferGeometry;
    if (!this.basePositions) {
      this.basePositions = geometry.attributes.position.array.slice() as Float32Array;
    }

    const position = geometry.attributes.position as THREE.BufferAttribute;
    const time = performance.now() * 0.001;

    for (let i = 0; i < position.count; i++) {
      const x = this.basePositions[i * 3];
      const y = this.basePositions[i * 3 + 1];
      const z = this.basePositions[i * 3 + 2];

      // Solo deformamos la superficie superior
      if (y > (this.length * this.percentageFull) / 2 - 0.5) {
        let wave = 0;
        this.waveParams.forEach(p => {
          wave += Math.sin(x * p.frequency + time * p.speed) * p.height;
          wave += Math.cos(z * p.frequency + time * p.speed * 0.8) * p.height;
        });
        position.setY(i, y + wave);
      }
    }

    position.needsUpdate = true;
    geometry.computeVertexNormals();
  }
}
